import { useCallback } from 'react'

import { CategoryBreadcrumb } from '@/legacy/components/CategoryBreadcrumb'
import { Image } from '@/legacy/components/Image'
import { ScreenReaderHidden } from '@/legacy/components/ScreenReaderHidden'
import { BodyP, HeadingS } from '@/legacy/components/Typography'
import { VisuallyHidden } from '@/legacy/components/VisuallyHidden'
import { useSelectCardEvent } from '@/legacy/core/analytics/hooks'
import { getFormattedDates } from '@/legacy/core/utils/dom/getFormattedDate'
import type { Category } from '@/legacy/models'

import BlogCardLoading from './BlogCardLoading'
import { BlogCardStyles } from './BlogCardStyles'

interface Props {
  title: string
  url: string
  image: string
  alt: string
  category: Category | null
  lastUpdated?: number | string
  className?: string
  modifier?: 'large' | 'default' | 'horizontal'
  forceFocus?: boolean
}

const BlogCard = ({
  title,
  image,
  alt,
  category,
  lastUpdated,
  url,
  className,
  modifier = 'default',
  forceFocus = false,
}: Props) => {
  const handleGAEvent = useSelectCardEvent()
  const formattedDate = (lastUpdated && getFormattedDates(lastUpdated)) || undefined
  const handleOnClickCard = useCallback(() => {
    handleGAEvent({ label: title })
  }, [handleGAEvent, title])
  return (
    <>
      <BlogCardStyles
        forceFocus={forceFocus}
        tag="a"
        aria-label={title}
        url={url}
        modifier={modifier}
        className={className}
        onClick={handleOnClickCard}
      >
        <div className="blog-card__cover">
          <Image
            source={image}
            alt={alt}
            layout="responsive"
            width={modifier === 'horizontal' ? 200 : 317}
            height={modifier === 'horizontal' ? 150 : 140}
            aria-hidden
          />
        </div>

        <ScreenReaderHidden as="div" className="blog-card__content">
          {category && <CategoryBreadcrumb category={category} noHref />}
          <HeadingS className="blog-card__title">{title}</HeadingS>
          <BodyP className="blog-card__infos" color="dark-medium">
            <span>{formattedDate?.visually}</span>
            <span>Time Serasa</span>
          </BodyP>
        </ScreenReaderHidden>
      </BlogCardStyles>

      <VisuallyHidden as="h2">{`${category && `categoria ${category.name}`}`}</VisuallyHidden>
      <VisuallyHidden as="p">{`Data de publicação ${formattedDate?.accessible}`}</VisuallyHidden>
      <VisuallyHidden as="p">Time Serasa</VisuallyHidden>
    </>
  )
}

BlogCard.Loading = BlogCardLoading

export default BlogCard
